





import { defineComponent } from '@vue/composition-api';

const History = defineComponent({
  // setup() {},
});

export default History;
